import { useState } from "react";
import { taskService } from "@miplatform/api";
import { ATTEMPT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { buildSearchQuery, isEmpty } from "@miplatform/utils";

export const useAttemptSearchViewModel = ({
  appendOrderTypeColor = () => {},
  searchableOrderTemplateIds = [],
}) => {
  const [attempts, setAttempts] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);

  const stateManager = useComponentState();

  const getAttempts = () => {
    stateManager.run(async () => {
      const searchQuery = buildSearchQuery(debouncedSearch, [
        "home.address.addressLine1",
      ]);

      const { status, data } = await taskService.attempts.getAll({
        filters: {
          ...(!isEmpty(searchableOrderTemplateIds) && {
            assignment: {
              order: {
                orderTemplateId: {
                  in: searchableOrderTemplateIds,
                },
              },
            },
          }),
          not: {
            attemptStatus: {
              in: [
                ATTEMPT_STATUSES.NEW,
                ATTEMPT_STATUSES.CANCELLED,
                ATTEMPT_STATUSES.HOLD,
              ],
            },
          },
          ...searchQuery,
        },
        sort: "scheduledStartDate desc",
        top: 25,
      });

      if (status === HTTP_STATUSES.OK) {
        setAttempts(appendOrderTypeColor(data));
      }
    });
  };

  return {
    attempts,
    search,
    debouncedSearch,
    stateManager,
    setSearch,
    getAttempts,
  };
};
